var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlames = function SvgFlames(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D5E0F5",
    d: "M13.966 9.368c-.183-2.386-1.294-3.882-2.275-5.201C10.784 2.945 10 1.89 10 .334a.334.334 0 0 0-.527-.271C8 1.116 6.773 2.89 6.343 4.585c-.297 1.18-.337 2.505-.342 3.38-1.36-.29-1.668-2.323-1.67-2.345a.335.335 0 0 0-.477-.253c-.07.035-1.75.887-1.847 4.292A6.007 6.007 0 0 0 8 16h.018A6.007 6.007 0 0 0 14 10c0-.165-.034-.631-.034-.631M8 15.333c-1.103 0-2-.956-2-2.13 0-.04 0-.08.003-.13.013-.496.107-.834.21-1.059.194.415.54.797 1.1.797a.333.333 0 0 0 .334-.333c0-.475.01-1.022.128-1.516.105-.438.357-.905.675-1.278.142.485.418.877.687 1.26.386.549.785 1.115.855 2.082q.007.085.008.177c0 1.174-.897 2.13-2 2.13"
  }))));
};
export default SvgFlames;